var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBetsFavOffSmaller = function SvgBetsFavOffSmaller(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 30.305,
    viewBox: "0 0 59 30.305",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12031",
    "data-name": "Group 12031",
    transform: "translate(-8 -345)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_783",
    "data-name": "Rectangle 783",
    width: 59,
    height: 30.305,
    rx: 15.152,
    transform: "translate(8 345)",
    fill: "#0f40a9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_bet_favorite",
    "data-name": "icon bet favorite",
    transform: "translate(30.816 348.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M0,0H10.981V17.905L5.634,13.926,0,17.905Z",
    transform: "translate(0 3.308)",
    fill: "#0f40a9",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M0,0H10.981V17.905L5.634,13.926,0,17.905Z",
    transform: "translate(0 3.308)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997",
    transform: "translate(4.746 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_995",
    "data-name": "Group 995",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    fill: "#0f40a9",
    stroke: "#0f40a9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.609,
    cy: 7.609,
    r: 7.609,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.609,
    cy: 7.609,
    r: 7.109,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996",
    transform: "translate(2.117 1.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M10.141,15.035l-2.677-.192a.143.143,0,0,1-.125-.092l-1.02-2.482a.9.9,0,0,0-1.659,0L3.638,14.756a.15.15,0,0,1-.125.092L.84,15.04a.884.884,0,0,0-.789.606.877.877,0,0,0,.266.968l2.069,1.709a.148.148,0,0,1,.049.148L1.8,21.051a.872.872,0,0,0,.141.763.892.892,0,0,0,.7.351.85.85,0,0,0,.472-.143l2.261-1.407a.147.147,0,0,1,.154,0l2.283,1.4a.855.855,0,0,0,.476.148.877.877,0,0,0,.678-.331.906.906,0,0,0,.172-.774l-.633-2.588a.151.151,0,0,1,.049-.15l2.1-1.713a.9.9,0,0,0-.521-1.574Zm.172,1.152L8.218,17.9a.7.7,0,0,0-.235.7l.633,2.583a.353.353,0,0,1-.067.306.329.329,0,0,1-.25.127.312.312,0,0,1-.179-.06L5.827,20.15a.7.7,0,0,0-.365-.1.686.686,0,0,0-.367.105l-2.27,1.411a.332.332,0,0,1-.443-.081.317.317,0,0,1-.047-.293l.633-2.59a.7.7,0,0,0-.233-.7L.672,16.194a.347.347,0,0,1,.206-.608l2.677-.192a.693.693,0,0,0,.593-.429L5.17,12.479a.348.348,0,0,1,.644,0l1.022,2.485a.693.693,0,0,0,.593.429l2.681.195a.337.337,0,0,1,.3.235A.345.345,0,0,1,10.313,16.187Z",
    transform: "translate(0 -11.714)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.7
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBetsFavOffSmaller, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1OSIgaGVpZ2h0PSIzMC4zMDUiIHZpZXdCb3g9IjAgMCA1OSAzMC4zMDUiPg0KICA8ZyBpZD0iR3JvdXBfMTIwMzEiIGRhdGEtbmFtZT0iR3JvdXAgMTIwMzEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04IC0zNDUpIj4NCiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzc4MyIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNzgzIiB3aWR0aD0iNTkiIGhlaWdodD0iMzAuMzA1IiByeD0iMTUuMTUyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4IDM0NSkiIGZpbGw9IiMwZjQwYTkiLz4NCiAgICA8ZyBpZD0iaWNvbl9iZXRfZmF2b3JpdGUiIGRhdGEtbmFtZT0iaWNvbiBiZXQgZmF2b3JpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMwLjgxNiAzNDguODc3KSI+DQogICAgICA8cGF0aCBpZD0iUGF0aF8xMTEzIiBkYXRhLW5hbWU9IlBhdGggMTExMyIgZD0iTTAsMEgxMC45ODFWMTcuOTA1TDUuNjM0LDEzLjkyNiwwLDE3LjkwNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMy4zMDgpIiBmaWxsPSIjMGY0MGE5IiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjciLz4NCiAgICAgIDxwYXRoIGlkPSJQYXRoXzExMTciIGRhdGEtbmFtZT0iUGF0aCAxMTE3IiBkPSJNMCwwSDEwLjk4MVYxNy45MDVMNS42MzQsMTMuOTI2LDAsMTcuOTA1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAzLjMwOCkiIGZpbGw9Im5vbmUiLz4NCiAgICAgIDxnIGlkPSJHcm91cF85OTciIGRhdGEtbmFtZT0iR3JvdXAgOTk3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0Ljc0NiAwKSI+DQogICAgICAgIDxnIGlkPSJHcm91cF85OTUiIGRhdGEtbmFtZT0iR3JvdXAgOTk1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwKSI+DQogICAgICAgICAgPGcgaWQ9IkVsbGlwc2VfMTU2IiBkYXRhLW5hbWU9IkVsbGlwc2UgMTU2IiBmaWxsPSIjMGY0MGE5IiBzdHJva2U9IiMwZjQwYTkiIHN0cm9rZS13aWR0aD0iMSI+DQogICAgICAgICAgICA8Y2lyY2xlIGN4PSI3LjYwOSIgY3k9IjcuNjA5IiByPSI3LjYwOSIgc3Ryb2tlPSJub25lIi8+DQogICAgICAgICAgICA8Y2lyY2xlIGN4PSI3LjYwOSIgY3k9IjcuNjA5IiByPSI3LjEwOSIgZmlsbD0ibm9uZSIvPg0KICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgICAgICA8ZyBpZD0iR3JvdXBfOTk2IiBkYXRhLW5hbWU9Ikdyb3VwIDk5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi4xMTcgMS42MjQpIj4NCiAgICAgICAgICA8cGF0aCBpZD0iUGF0aF81NSIgZGF0YS1uYW1lPSJQYXRoIDU1IiBkPSJNMTAuMTQxLDE1LjAzNWwtMi42NzctLjE5MmEuMTQzLjE0MywwLDAsMS0uMTI1LS4wOTJsLTEuMDItMi40ODJhLjkuOSwwLDAsMC0xLjY1OSwwTDMuNjM4LDE0Ljc1NmEuMTUuMTUsMCwwLDEtLjEyNS4wOTJMLjg0LDE1LjA0YS44ODQuODg0LDAsMCwwLS43ODkuNjA2Ljg3Ny44NzcsMCwwLDAsLjI2Ni45NjhsMi4wNjksMS43MDlhLjE0OC4xNDgsMCwwLDEsLjA0OS4xNDhMMS44LDIxLjA1MWEuODcyLjg3MiwwLDAsMCwuMTQxLjc2My44OTIuODkyLDAsMCwwLC43LjM1MS44NS44NSwwLDAsMCwuNDcyLS4xNDNsMi4yNjEtMS40MDdhLjE0Ny4xNDcsMCwwLDEsLjE1NCwwbDIuMjgzLDEuNGEuODU1Ljg1NSwwLDAsMCwuNDc2LjE0OC44NzcuODc3LDAsMCwwLC42NzgtLjMzMS45MDYuOTA2LDAsMCwwLC4xNzItLjc3NGwtLjYzMy0yLjU4OGEuMTUxLjE1MSwwLDAsMSwuMDQ5LS4xNWwyLjEtMS43MTNhLjkuOSwwLDAsMC0uNTIxLTEuNTc0Wm0uMTcyLDEuMTUyTDguMjE4LDE3LjlhLjcuNywwLDAsMC0uMjM1LjdsLjYzMywyLjU4M2EuMzUzLjM1MywwLDAsMS0uMDY3LjMwNi4zMjkuMzI5LDAsMCwxLS4yNS4xMjcuMzEyLjMxMiwwLDAsMS0uMTc5LS4wNkw1LjgyNywyMC4xNWEuNy43LDAsMCwwLS4zNjUtLjEuNjg2LjY4NiwwLDAsMC0uMzY3LjEwNWwtMi4yNywxLjQxMWEuMzMyLjMzMiwwLDAsMS0uNDQzLS4wODEuMzE3LjMxNywwLDAsMS0uMDQ3LS4yOTNsLjYzMy0yLjU5YS43LjcsMCwwLDAtLjIzMy0uN0wuNjcyLDE2LjE5NGEuMzQ3LjM0NywwLDAsMSwuMjA2LS42MDhsMi42NzctLjE5MmEuNjkzLjY5MywwLDAsMCwuNTkzLS40MjlMNS4xNywxMi40NzlhLjM0OC4zNDgsMCwwLDEsLjY0NCwwbDEuMDIyLDIuNDg1YS42OTMuNjkzLDAsMCwwLC41OTMuNDI5bDIuNjgxLjE5NWEuMzM3LjMzNywwLDAsMSwuMy4yMzVBLjM0NS4zNDUsMCwwLDEsMTAuMzEzLDE2LjE4N1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTExLjcxNCkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIwLjciLz4NCiAgICAgICAgPC9nPg0KICAgICAgPC9nPg0KICAgIDwvZz4NCiAgPC9nPg0KPC9zdmc+DQo=";
export { ForwardRef as ReactComponent };